import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { CoreService } from "../core-services/core.service";
import { Game } from "../core-services/games/games.model";
import { GameProvider } from "./games-filter-categories.models";

@Injectable()
export class GameFilterCategoriesService {
    constructor(
        private http: HttpClient,
        private coreService: CoreService
    ) {
    }

    public getGameProviders(): Observable<GameProvider[]> {
        return this.http.get<GameProvider[]>(this.coreService.legacyUrl + `/ajax/getproviders.php`);
    }

    /*
    * @todo - idealy BE provide some sort of id that we could use to query additional provider details,
    * example: all provider games, provider game categories
    */
    public createProviderId(providerName: string): string {
        return providerName.toLowerCase().replace(/\W+/g, '-');
    }

    public revertProviderId(providerName: string): string {
        return providerName.toLowerCase().replace(/-/g, ' ');
    }

    public sortGames(games: Game[], ascending?: boolean): Game[] {
        if (ascending) {
            return games.sort((firstValue, secondValue) => (firstValue.name > secondValue.name ? 1 : -1));
        }
        return games.sort((firstValue, secondValue) => (firstValue.name > secondValue.name ? -1 : 1));
    }
}
